import Entity from './entity'
import HandoverSessionPackageInfo from './handoversessionpackageinfo'
export default class HandoverSessionUpdateDetail extends Entity<number>{
    code:string;
    refCode :string;
    refTypeCode :string;
    transferredBy :number;
    transferredTime : Date;
    deliveryPartnerName :string;
    numOfPackages :number;
    status:string;
    canDelete: boolean;
    transferred : boolean;
    sessionType:string;
    transferredUserName:string;
    creatorUserName:string;
    notDone: boolean;
    creatorUserId : string;
    creationTime : Date;
    itemType:string;
    note:string;
    refTypeName:string;
    items:Array<HandoverSessionPackageInfo>;
}
